import * as React from "react";
import { useGetCLByPrescription } from "../../../../api/modules/EcommContent/ContactLensesEcommContent/hooks/api/use-get-cl-by-prescription.js";
import { mapClientToServerPrescription } from "../../../../api/mappers/client-to-server/modules/EcommContent/ContactLensesEcommContent/hooks/api/mappers/client-to-server/map-client-to-server-prescription.js";
import { useCLEcommContext } from "../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
import { useContactLensProductData } from "../../../../../../../../context/context/product-context-hooks.js";
import { isNonRecoverableError } from "../../../../../../../../types/types/typeguards.js";
const useFetchCLByPrescription = ({ eyeSide }) => {
  const { actions, maxOrderableQuantity, triggerToastMessage } = useCLEcommContext();
  const {
    activeVariant: { masterVariantSku, sku: activeSku }
  } = useContactLensProductData();
  const onSuccess = React.useCallback(
    (result) => {
      const { prescriptionCLProduct } = result;
      actions.updateQueryResult({
        eyeSide,
        maxOrderableQuantity,
        prescriptionCLProduct
      });
    },
    [actions, eyeSide, maxOrderableQuantity]
  );
  const onError = React.useCallback(
    (result) => {
      actions.updateQueryResult({ eyeSide, maxOrderableQuantity, error: result.error });
      if (isNonRecoverableError(result.error)) {
        triggerToastMessage("non-recoverable-rx-error");
      }
    },
    [actions, eyeSide, maxOrderableQuantity, triggerToastMessage]
  );
  const getCLByPrescription = useGetCLByPrescription({
    onSuccess,
    onError
  });
  const fetchCLByPrescription = React.useCallback(
    (columnConfigurations) => {
      const prescription = mapClientToServerPrescription(columnConfigurations);
      if (prescription) {
        actions.setQueryLoading({ eyeSide, loading: true });
        getCLByPrescription({ masterVariantSku, prescription }, activeSku);
      }
    },
    [actions, activeSku, masterVariantSku, eyeSide, getCLByPrescription]
  );
  return fetchCLByPrescription;
};
export {
  useFetchCLByPrescription
};
//# sourceMappingURL=use-fetch-cl-by-prescription.js.map
